(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('ImpegnoSearch', ImpegnoSearch);

    ImpegnoSearch.$inject = ['$resource'];

    function ImpegnoSearch($resource) {
        var resourceUrl =  'api/_search/impegnos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
